import React, { FC } from 'react';
import { useConfig } from 'icerockdev-admin-toolkit';
import { observer } from 'mobx-react';

import styles from './styles.module.scss';

interface IProps {}

const Layout: FC<IProps> = observer(({ children }) => {
  const config = useConfig();
  const splash = config.auth?.splash || '';

  return (
    <div className={styles.layout}>
      <div className={styles.left}>
        <div className={styles.left__wrap}>
          <div className={styles.form}>
            <div className={styles.content}>{children}</div>
          </div>
        </div>
      </div>

      <div className={styles.image} style={{ backgroundImage: `url('${splash}')` }} />
    </div>
  );
});

export default Layout;
